module.exports = __WEBPACK_EXTERNAL_MODULE_46__;


//////////////////
// WEBPACK FOOTER
// external "@angular/common"
// module id = 46
// module chunks = 0